<template>
    <div class="provideCard">
        <h4>Provide a Debit Card</h4>

        <form @submit.prevent="submit">
            <div class="inputTwoCols">
                <Input
                    :label="'components/payment/provide-card.name-on-card' | trans"
                    id="name"
                    v-model="name"
                    :v="$v.name"
                    :requiredMessage="'components/payment/provide-card.name-is-required' | trans"
                />
                <Input
                    :label="'components/payment/provide-card.card-number' | trans"
                    id="card_number"
                    :v="$v.cardNumber"
                    v-model="cardNumber"
                    maxlength="19"
					card-must-have-min-count-numbers
                    :minLengthMessage="'components/payment/provide-card.card-number' | trans({count: 12})"
                    :numbersAndSpacesMessage="'should-only-contain-numbers' | trans"
                />
            </div>
            <div class="inputThreeCols">
                <div class="selectWrap" :class="{'hasError' : selectsValidation.expiryDayError}">
                    <label>{{'components/payment/provide-card.expiry-date' | trans}}</label>

                    <v-select
                        :options="expiryDateDay"
                        v-model.number="expiryDateDaySelected"
                    />
                    <div class="error" v-if="selectsValidation.expiryDayError">
                        Date is required
                    </div>
                </div>
                <div class="selectWrap" :class="{'hasError' : selectsValidation.expiryMonthError}">
                    <label class="transparent">{{'components/payment/provide-card.expiry-date' | trans}}</label>
                    <v-select
                        :options="expiryDateMonth"
                        v-model="expiryDateMonthSelected"
                    />
                    <div class="error" v-if="selectsValidation.expiryMonthError">
						{{'components/payment/provide-card.date-required' | trans}}
                    </div>
                </div>
                <Input
                    label="CVV"
                    id="cvv"
                    :v="$v.cvv"
                    v-model="cvv"
                    maxlength="3"
                    :requiredMessage="'components/payment/provide-card.cvv-is-required' | trans"
                />
            </div>
            <div class="billingAddress selectWrap" :class="{'hasError' : selectsValidation.billingAddressError}">
                <label>{{'components/payment/provide-card.select-billing-address' | trans}}</label>
                <v-select
                    :options="billingAddresses"
                    v-model="billingAddressSelected"
                />
                <div class="error" v-if="selectsValidation.billingAddressError">
					{{'components/payment/provide-card.billing-address-is-required' | trans}}
                </div>
            </div>
            <div class="futurePayments">
                <h4 class="title">{{'components/payment/provide-card.use-card-for-all-future-payments' | trans}}</h4>

                <Switcher v-model="futurePayments"/>

            </div>
            <button selectsValidation class="btn process">{{'components/payment/provide-card.process-payment' | trans}}</button>
        </form>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import moment from 'moment';
    import Input from '../form/Input';
    import Switcher from '../form/Switcher';
    import {required, minLength, maxLength, numeric} from 'vuelidate/lib/validators';
    import {creditCardFormatInput, numbersAndSpaces} from '../../helpers/form';
    import {mapActions, mapState} from 'vuex'

    export default {
        data() {
            return {
                name: '',
                cardNumber: null,
                expiryDateDay: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                expiryDateMonth: [
                    lang.get('components/payment/provide-card.months.January'),
                    lang.get('components/payment/provide-card.months.February'),
                    lang.get('components/payment/provide-card.months.March'),
                    lang.get('components/payment/provide-card.months.April'),
                    lang.get('components/payment/provide-card.months.May'),
                    lang.get('components/payment/provide-card.months.June'),
                    lang.get('components/payment/provide-card.months.July'),
                    lang.get('components/payment/provide-card.months.August'),
                    lang.get('components/payment/provide-card.months.September'),
                    lang.get('components/payment/provide-card.months.October'),
                    lang.get('components/payment/provide-card.months.November'),
                    lang.get('components/payment/provide-card.months.December'),
                ],
                expiryDateDaySelected: null,
                expiryDateMonthSelected: '',
                cvv: null,
                billingAddressSelected: '',
                futurePayments: false,
                selectsValidation: {
                    expiryMonthError: false,
                    expiryDayError: false,
                    billingAddressError: false
                }
            }
        },
        validations: {
            name: {
                required
            },
            cardNumber: {
                required,
                numbersAndSpaces,
                minLength: minLength(19), //because of spacing in creditCardFormatInput function
                maxLength: maxLength(19)  //because of spacing
            },
            cvv: {
                required,
                minLength: minLength(3),
                numeric
            }
        },
        props: {
            amountType: {
                type: String
            },
            customAmountValue: {
                type: Number
            }
        },
        components: {
            vSelect,
            Input,
            Switcher
        },
        computed: {
            ...mapState(['addressBook']),
            billingAddresses: function () {
                let billingAddressesBuffer = [];
                for (let address of this.addressBook) {
                    billingAddressesBuffer.push({
                        value: address.id,
                        label: address.full_address
                    });
                }
                return billingAddressesBuffer;
            }
        },
        methods: {
            submit: function () {

                this.validateExpiryMonth();
                this.validateExpiryDay();
                this.validatebillingAddress();

                this.$v.$touch();

                if (this.$v.$pending || this.$v.$error || !this.expiryDateMonthSelected || !this.expiryDateDaySelected || !this.billingAddressSelected) return;
                // to form submit after this
                const data = {
                    name: this.name,
                    card_umber: this.cardNumber,
                    expiry_date_month: moment(this.expiryDateMonthSelected, 'MMM').format('M'),
                    expiry_date_day: moment(this.expiryDateDaySelected, 'MMM').format('M'),
                    cvv: this.cvv,
                    billing_address: this.billingAddressSelected,
                    future_payments: this.futurePayments
                }
                console.log(data);
                //TODO post data to api

            },

            validateExpiryMonth: function () {
                this.expiryDateMonthSelected ? this.selectsValidation.expiryMonthError = false : this.selectsValidation.expiryMonthError = true;
            },
            validateExpiryDay: function () {
                this.expiryDateDaySelected ? this.selectsValidation.expiryDayError = false : this.selectsValidation.expiryDayError = true;
            },
            validatebillingAddress: function () {
                this.billingAddressSelected ? this.selectsValidation.billingAddressError = false : this.selectsValidation.billingAddressError = true;
            }

        },
        watch: {
            cardNumber: function () {
                this.cardNumber = creditCardFormatInput(this.cardNumber);
            },
            expiryDateMonthSelected: function () {
                this.validateExpiryMonth();
            },
            expiryDateDaySelected: function () {
                this.validateExpiryDay();
            },
            billingAddressSelected: function () {
                this.validatebillingAddress();
            }
        }
    }
</script>
